import { useEffect, useRef, useState } from 'react';

export function useSearchHistory<T extends object>(cleanState: T): [T, (state: T) => void] {
    const onPopStateRef = useRef((event: PopStateEvent) => onPopState(event.state));
    const [state, setState] = useState<T>({ ...cleanState, ...window.history.state });

    useEffect(() => {
        window.addEventListener('popstate', onPopStateRef.current);

        return () => window.removeEventListener('popstate', onPopStateRef.current);
    }, []);

    function onPopState(stateFromHistory: T) {
        setState({ ...cleanState, ...stateFromHistory });
    }

    function pushHistory(newHistoryState: T) {
        setState(newHistoryState);
        window.history.pushState(newHistoryState, '');
    }

    return [state, pushHistory];
}
